import Parse from "parse";
export class Log extends Parse.Object {
    constructor(data) {
        super("OD3_Log", data);
    }
    get references() {
        return super.get("references");
    }
    set references(value) {
        super.set("references", value);
    }
    get type() {
        return super.get("type");
    }
    set type(value) {
        super.set("type", value);
    }
}
Log.className = "OD3_Log";
Parse.Object.registerSubclass("OD3_Log", Log);
//# sourceMappingURL=Log.js.map